import React from 'react'
import getLabel from '../../utilities/label.js'

export default function PreauthInputForm(props){
  const {
    changeEmail,
    changePassword,
    submit,
    openLoginSupport
  } = props
  return (
    <div className="preauth-input-form">
      <h3>{ getLabel('sign_in_button') }</h3>
      <form>
        <div className='preauth-input-form-inner'>
          <div className='form-group input-wrapper'>
            <input
              type='text'
              className='form-control'
              id='email'
              placeholder={ getLabel('username') }
              onChange={ changeEmail } />
          </div>
          <div className='form-group input-wrapper bottom-input'>
            <input
              type='password'
              className='form-control'
              placeholder={ getLabel('password') }
              onChange={ changePassword } />
          </div>
          <button
            onClick={ submit }
            className='submit-button'>{ getLabel('sign_in_button') }</button>
        </div>
      </form>
      <br />
      <button
        className="forgot-password-button"
        onClick={ openLoginSupport }>
        { getLabel('need_help') }
      </button>
    </div>
  )
}
